import type { FC, SVGProps } from "react";

const PauseIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="pause video icon">
      {/* <title>pause video icon</title> */}
      <path
        d="M17.6 2L16 2C14.6745 2 13.6 3.11665 13.6 4.44739L13.6 19.4123C13.6 20.7898 14.6745 21.9065 16 21.9065L17.6 22C18.9255 22 20 20.8833 20 19.5058L20 4.54092C20 3.16342 18.925 2 17.6 2ZM8 2L6.4 2C5.0745 2 4 3.11665 4 4.49415L4 19.4591C4 20.8828 5.0745 22 6.4 22H8C9.3255 22 10.4 20.8833 10.4 19.5058L10.4 4.54092C10.4 3.16342 9.325 2 8 2Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default PauseIcon;
